"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateStringLength = exports.capitalize = void 0;
var memoize = require("fast-memoize");
var canvas = document.createElement('canvas');
var ctx = canvas.getContext('2d');
if (ctx) {
    ctx.font = '13px "Roboto", sans-serif';
}
function _calc(text) {
    if (ctx && text && text.length > 0) {
        var temp = ctx.measureText(text);
        return temp.width;
    }
    return 0;
}
var capitalize = function (str) {
    var lower = str.toLowerCase();
    return lower.substr(0, 1).toUpperCase() + lower.substr(1);
};
exports.capitalize = capitalize;
exports.calculateStringLength = memoize(_calc);
